import { useEffect, createContext, useContext, useState } from 'react'

const PageTitleContext = createContext<{
  title: string
  setTitle: (title: string) => void
}>({ title: '', setTitle: () => {} })

export const PageTitleProvider = PageTitleContext.Provider

export function usePageTitleState() {
  const [title, setTitle] = useState('')
  return { title, setTitle }
}

export function usePageTitle(title: string) {
  const ctx = useContext(PageTitleContext)

  useEffect(() => {
    document.title = title ? `${title} - Shopbay` : 'Shopbay'
    ctx.setTitle(title)
  }, [title, ctx])
}

export function useCurrentPageTitle() {
  return useContext(PageTitleContext).title
}
